<form [formGroup]="form" *ngIf="form && MEASUREMENT_CALCULATIONS">
  <div class="form-body">
    <div class="form-section">

      <div class="measurementCalculations">
        <div class="measurementCalculations-tabs">

          <tabset #navTabs class="tabNav">
            <ng-container *ngFor="let measurementCalculations of MEASUREMENT_CALCULATIONS; let i=index;">
              <tab heading="{{ measurementCalculations.title | translate }}">
                <div *ngIf="navTabs.tabs[i]?.active" class="measurementCalculations-image">
                  <img src="assets/common/images/measurement-calculations/{{ measurementCalculations.img }}">
                </div>
              </tab>
            </ng-container>
          </tabset>

        </div>
        <div class="measurementCalculations-content">
          <div class="row">
            <ng-container *ngFor="let tab of MEASUREMENT_CALCULATIONS; let i=index;">
              <ng-container *ngIf="navTabs.tabs[i]?.active">

                <ng-container *ngFor="let colGroups of tab.groups">
                  <div class="col-6">
                    <div *ngFor="let group of colGroups" class="measurementCalculationsGroup">

                      <div class="h5 measurementCalculationsGroup-title">{{ group.title | translate }}</div>
                      <div *ngFor="let item of group.items">
                        <app-form-row [label]="item.label | translateControl : getFormControlGroup(tab.id) | async">
                          <div *ngIf="item.type === measurementCalculationsItemType.READONLY; else inputType"
                            class="measurementCalculationsGroup-value">
                            <ng-container *ngIf="(item.value | isArray); else printValue">
                              <ng-container *ngFor="let v of item.value; let i = index;">
                                <span *ngIf="i!==0">/</span>
                                <span>{{ v }} mm</span>
                              </ng-container>
                            </ng-container>
                            <ng-template #printValue>
                              <span>{{ item.value }}</span>
                            </ng-template>
                          </div>
                          <ng-template #inputType>
                            <app-input [type]="'number'" [mainForm]="getFormControlGroup(tab.id)"
                              [controlName]="item.controlName" [suffix]="'mm'">
                            </app-input>
                          </ng-template>
                        </app-form-row>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </div>
</form>
